/**
 * useTeacherAuth.ts
 * Tracks the signed-in teacher (email/password). Keeps the store's
 * teacherUid in sync and reports loading state so the task pane can
 * show a login screen until auth resolves.
 */

import { useEffect, useState } from 'react';
import type { User } from 'firebase/auth';
import { onTeacherAuthChanged, getUserTier } from '@db/firebase';
import { useAppStore } from '@store/appStore';

export function useTeacherAuth(): { user: User | null; loading: boolean } {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);
  const setTeacherUid = useAppStore((s) => s.setTeacherUid);
  const setTier = useAppStore((s) => s.setTier);

  useEffect(() => {
    return onTeacherAuthChanged(async (u) => {
      setUser(u);
      setTeacherUid(u?.uid ?? null);
      if (u) {
        setTier(await getUserTier(u.uid));
      } else {
        setTier('free');
      }
      setLoading(false);
    });
  }, [setTeacherUid, setTier]);

  return { user, loading };
}
